var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageModalActivePage === 'proposition')?_c('PropositionPage',{attrs:{"proposition-id":_vm.propositionViewModalId,"in-modal":true}}):_vm._e(),(_vm.pageModalActivePage === 'swapdetails')?_c('SwapView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }